import * as types from './action-types'

function handleErrors(res) {
  if (!res.ok) throw Error(res.statusText)
  return res
}

const requestCaseStudyRows = () => ({
  type: types.REQUEST_CASE_STUDY_ROWS
})

const receiveCaseStudyRows = data => ({
  type: types.RECEIVE_CASE_STUDY_ROWS,
  payload: {
    data,
    receivedAt: Date.now()
  }
})

const errorCaseStudyRows = () => ({
  type: types.ERROR_CASE_STUDY_ROWS
})

export const fetchCaseStudyRows = () => dispatch => {
  dispatch(requestCaseStudyRows());

  return fetch('/api/showcase')
    .then(handleErrors)
    .then(res => res.json())
    .then(json => dispatch(receiveCaseStudyRows(json)))
    .catch(e => dispatch(errorCaseStudyRows(e)))
}



// WEBPACK FOOTER //
// ./src/components/case-studies-container/actions.js